import clsx from "clsx";
import type { ReactNode } from "react";

export type PatientContentLayoutProps = {
  children: ReactNode;
  /**
   * - "tabs": content below navbar + patient menu + tabs (auction pages)
   * - "menu": content below navbar + patient menu only (consultation pages)
   */
  variant?: "menu" | "tabs";
};

export function PatientContentLayout({
  children,
  variant = "tabs",
}: PatientContentLayoutProps) {
  return (
    <div
      className={clsx("mx-auto flex w-full max-w-7xl flex-1 flex-col p-4", {
        "min-h-below-navbar-patient-menu": variant === "menu",
        "min-h-below-navbar-patient-menu-tabs": variant === "tabs",
      })}
      data-testid="patient-content-layout"
    >
      {children}
    </div>
  );
}
